// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"253":"38d621cf","260":"38d621cf","341":"38d621cf","478":"38d621cf","550":"38d621cf","861":"38d621cf"}[chunkId] + ".chunk.css";
};